const activeClass = 'b-accordion_is_open';
const timeDelay = 300;

class Accordion {
    constructor($accordion) {
        this.$accordion = $accordion;
        this.$content = this.$accordion.find('.j-accordion-content');
        this.$header= this.$accordion.find('.j-accordion-header');
    }

    init() {
        this._bindEvents();
    }

    _bindEvents() {
        this.$header.on('click', this._onClickHeader.bind(this));
    }

    _onClickHeader() {
        this._toggleVisibleContent();
        this._changeState();
    }

    _toggleVisibleContent() {
        this.$content.slideToggle(timeDelay);
    }

    _changeState() {
        this.$accordion
            .toggleClass(activeClass);
    }
}

export default Accordion;
